export enum EndpointsConditionsQueryKeys {
  TokenizationApplication = '/tokenization/salom/application',
  TokenizationTranche = '/tokenization/salom/tranche',
}
